<template>
  <div class="jxxf-home">
    <div class="jxxf-home__inner">
      <header class="jxxf-home__header">
        <div class="jxxf-home__identity">
          <span class="jxxf-home__identity-mark" />
          江西消防技术服务
        </div>
        <h1 class="jxxf-home__title">
          业务工作台
        </h1>
        <p class="jxxf-home__subtitle">
          维保、检测与评估业务统一入口
        </p>
      </header>

      <section class="jxxf-home__section">
        <div class="jxxf-home__section-heading">
          <h2>业务入口</h2>
          <span>{{ availableCount }} 个模块可用</span>
        </div>
        <div class="jxxf-home__entries">
          <button
            v-for="item in items"
            :key="item.code"
            class="jxxf-home__entry"
            :class="[`jxxf-home__entry--${item.theme}`, { 'is-disabled': !item.route }]"
            type="button"
            :disabled="!item.route"
            :aria-label="item.route ? `进入${item.name}` : `${item.name}暂未开放`"
            @click="go(item)"
          >
            <span class="jxxf-home__entry-top">
              <span class="jxxf-home__entry-icon">
                <i :class="item.icon" />
              </span>
              <span
                class="jxxf-home__entry-status"
                :class="{ 'is-pending': !item.route }"
              >
                {{ item.route ? '可用' : '暂未开放' }}
              </span>
            </span>
            <span class="jxxf-home__entry-content">
              <strong>{{ item.name }}</strong>
              <small>{{ item.subtitle }}</small>
            </span>
            <span class="jxxf-home__entry-action">
              {{ item.route ? '进入模块' : '功能建设中' }}
              <i
                v-if="item.route"
                class="el-icon-right"
              />
              <i
                v-else
                class="el-icon-lock"
              />
            </span>
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JxxfHome',
  data () {
    return {
      items: [
        {
          code: 'wb',
          name: '维保业务',
          subtitle: '项目、计划与维保报告',
          route: 'jxxfWbProjectIndex',
          icon: 'el-icon-s-tools',
          theme: 'maintenance'
        },
        {
          code: 'jc',
          name: '检测业务',
          subtitle: '项目、现场检测与报告',
          route: 'jxxfJcProjectIndex',
          icon: 'el-icon-search',
          theme: 'inspection'
        },
        {
          code: 'pg',
          name: '评估业务',
          subtitle: '消防安全评估',
          route: 'jxxfPgxmManage',
          icon: 'el-icon-data-analysis',
          theme: 'assessment'
        }
      ]
    };
  },
  computed: {
    availableCount () {
      return this.items.filter(item => item.route).length;
    }
  },
  methods: {
    /** 进入已建设的江西业务模块。 */
    go (item) {
      if (item.route) this.$router.push({ name: item.route });
    }
  }
};
</script>

<style scoped lang="scss">
.jxxf-home {
  min-height: 100%;
  padding: 32px 36px 48px;
  box-sizing: border-box;
  color: #1f2937;
  background: #f5f7fa;

  &__inner {
    max-width: 1280px;
    margin: 0 auto;
  }

  &__header {
    padding: 6px 0 28px 18px;
    border-left: 4px solid #c2413b;
  }

  &__identity {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #6b7280;
  }

  &__identity-mark {
    width: 8px;
    height: 8px;
    background: #c2413b;
    border-radius: 2px;
  }

  &__title {
    margin: 8px 0 0;
    font-size: 28px;
    line-height: 1.35;
    font-weight: 600;
    letter-spacing: 0;
    color: #111827;
  }

  &__subtitle {
    margin: 6px 0 0;
    font-size: 14px;
    line-height: 1.5;
    color: #6b7280;
  }

  &__section {
    padding-top: 20px;
    border-top: 1px solid #e5e7eb;
  }

  &__section-heading {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 16px;

    h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0;
      color: #111827;
    }

    span {
      font-size: 13px;
      color: #8a94a3;
    }
  }

  &__entries {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px;
  }

  &__entry {
    --entry-color: #0f766e;
    --entry-soft: #e6f4f1;

    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 230px;
    padding: 24px;
    overflow: hidden;
    text-align: left;
    color: #1f2937;
    background: #fff;
    border: 1px solid #e1e6ed;
    border-top: 3px solid var(--entry-color);
    border-radius: 6px;
    box-shadow: 0 2px 7px rgba(31, 41, 55, 0.05);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover:not(:disabled) {
      transform: translateY(-3px);
      box-shadow: 0 12px 28px rgba(31, 41, 55, 0.12);
    }

    &:focus-visible {
      outline: 3px solid var(--entry-soft);
      outline-offset: 3px;
    }

    &--inspection {
      --entry-color: #2563a7;
      --entry-soft: #e7f0fa;
    }

    &--assessment {
      --entry-color: #7c8798;
      --entry-soft: #eef1f5;
    }

    &.is-disabled {
      color: #6b7280;
      background: #fafbfc;
      cursor: not-allowed;
      box-shadow: none;
    }
  }

  &__entry-top,
  &__entry-action {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__entry-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    color: var(--entry-color);
    background: var(--entry-soft);
    border-radius: 6px;

    i {
      font-size: 24px;
    }
  }

  &__entry-status {
    padding: 4px 9px;
    font-size: 12px;
    line-height: 18px;
    color: #0f766e;
    background: #e8f5f1;
    border-radius: 3px;

    &.is-pending {
      color: #6b7280;
      background: #edf0f4;
    }
  }

  &__entry-content {
    display: flex;
    flex-direction: column;
    gap: 7px;
    margin-top: 28px;

    strong {
      overflow-wrap: anywhere;
      font-size: 21px;
      line-height: 1.4;
      font-weight: 600;
      letter-spacing: 0;
      color: #111827;
    }

    small {
      overflow-wrap: anywhere;
      font-size: 14px;
      line-height: 1.5;
      color: #6b7280;
    }
  }

  &__entry-action {
    justify-content: flex-start;
    gap: 7px;
    margin-top: auto;
    padding-top: 24px;
    font-size: 13px;
    color: var(--entry-color);

    i {
      font-size: 14px;
    }
  }
}

@media (max-width: 980px) {
  .jxxf-home {
    padding: 28px 24px 40px;

    &__entries {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    &__entry {
      min-height: 205px;
    }
  }
}

@media (max-width: 640px) {
  .jxxf-home {
    padding: 22px 16px 32px;

    &__entries {
      grid-template-columns: 1fr;
    }

    &__title {
      font-size: 24px;
    }

    &__entry {
      padding: 20px;
    }
  }
}
</style>
